import http from "../../services/http-common";
import securityService from '../security/security.service'
import moment from "moment";
class IssueInvoiceService {
    getForList() {
        return http.get(`/IssueInvoice/db/table`);
    }

    getIssueInvoiceDetail(IssueInvoiceDate,IssueInvoiceID,   CompanyID = securityService.getCompanyIDLoggedInUserId()) {
        let queryParams = new URLSearchParams({FromDate:'01-Jan-01',ToDate:IssueInvoiceDate,IssueInvoiceID,CompanyID:securityService.getCompanyIDLoggedInUserId()}).toString();
        return http.get(`/IssueInvoice/db/table/detail?${queryParams}`);
    }

    getProductStock(data) {
      console.log(data)
        let queryParams = new URLSearchParams({CompanyID:data.CompanyID, FromDate:data.FromDate, ToDate:data.ToDate, CostCenterID:data.CostCenterID, ProductID:data.ProductID}).toString();
        return http.get(`/IssueInvoice/product/stock?${queryParams}`);
    }

     getStartDate() {
      let startDate = ''
      return http
          .get(`/IssueInvoice/getStartDate/${securityService.getCompanyIDLoggedInUserId()}`)
          .then(res => {
              let startDates = res.data.recordset[0].StartDate;
              startDate = moment(startDates).format('DD-MMM-YY');
          });
      return startDate
  }
  
    addIssueInvoice(data){
      return http.post(`/IssueInvoice/add`,data);
    }
    addIssueInvoiceDetail(data){
      return http.post(`/IssueInvoice/detail/add`,data);
    }

    editIssueInvoice(data){
      return http.put(`/IssueInvoice/edit`,data);
    }
    editIssueInvoiceDetail(data){
      return http.put(`/IssueInvoice/grid/edit`,data);
    }

    }

export default new IssueInvoiceService();
